<template>
	<div class="page_order_card ">
		<div
			:class="{
                'border-bottom':border
            }"
			class="title "
			>{{title}}</div
		>
		<slot></slot>
	</div>
</template>
<script>
export default {
    name: 'PageOrderCard',
    props: {
        border: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        }
    }
}
</script>
<style lang="less" scoped>
.border-bottom {
	border-bottom: 1px solid #eff0f1;
}
.page_order_card {
	border-radius: 16px;
	background-color: #ffffff;
	padding: 32px 28px;
	.title {
		font-size: 30px;
		color: #000000;
		font-weight: bold;
		padding-bottom: 28px;
	}
}
</style>